import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import MenuModule from '@/store/modules/menu.js';
import CommonRouter from '@/router/common.js';
import NProgress from 'nprogress';
import auth from '@/views/login/auth';
import 'nprogress/nprogress.css';
import initMapTilelayer from '@/components/map/init';
import { getAuthStorage, getGlobalConfig, removeAllStorage, getUserConfigByToken } from '@/api/service-localstorage';
import { isEmpty } from 'lodash';
import initSocketIo from '@/components/socket.io';
import { action } from "./views/qiankun/action";
NProgress.configure({
  showSpinner: false
});
/**
 * 登录数据结构
 * {
 *    cookies: String    @用于header中验证
 *    projectId: String  @全局唯一id
 * }
 */

var flatCommonArry = []; // 扁平化路由数据

function flatArray(arr) {
  var source = [];

  var flat = function flat(item) {
    if (item.children instanceof Array) {
      source.push.apply(source, _toConsumableArray(item.children));
    } else {
      source.push(item);
    }
  };

  arr.forEach(flat);
  return source;
} // 获取并合并配置文件


function mergeConfig(_x) {
  return _mergeConfig.apply(this, arguments);
} // 所有的登录成功初始化都再这里面做掉


function _mergeConfig() {
  _mergeConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(projectId) {
    var _yield$Promise$all, _yield$Promise$all2, global, user, _user$map, mapConfig, _user$warn, riskEarlyWarningProperty, attentionCity;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([getGlobalConfig(projectId), getUserConfigByToken()]);

          case 2:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            global = _yield$Promise$all2[0];
            user = _yield$Promise$all2[1];

            if (user) {
              _context2.next = 8;
              break;
            }

            return _context2.abrupt("return", global);

          case 8:
            _user$map = user.map, mapConfig = _user$map === void 0 ? {} : _user$map, _user$warn = user.warn, riskEarlyWarningProperty = _user$warn === void 0 ? {} : _user$warn;
            attentionCity = mapConfig.attentionCity;

            if (isEmpty(attentionCity)) {
              mapConfig.attentionCity = global.mapConfig.attentionCity; // 假装赋值

              mapConfig.attention_bounds_disaster = global.mapConfig.attention_bounds_disaster;
              mapConfig.attention_bounds_forecast = global.mapConfig.attention_bounds_forecast;
            } // 外置到最外层


            global.cityCode = mapConfig.attentionCity.adcode;
            global.cityName = mapConfig.attentionCity.name;
            global.cityLat = mapConfig.attentionCity.lat;
            global.cityLng = mapConfig.attentionCity.lng;
            global.cityBounds = mapConfig.attention_bounds_forecast;
            global.mapConfig = Object.assign({}, global.mapConfig, mapConfig); // 合并全局地图配置，用户优先级更高

            global.riskEarlyWarningProperty = riskEarlyWarningProperty;
            return _context2.abrupt("return", global);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _mergeConfig.apply(this, arguments);
}

var initRouter = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, router, projectId) {
    var _firstModule$children;

    var _getAuthStorage, _getAuthStorage$cooki, cookies, _getAuthStorage$acces, accesstoken, headName, newModule, currentMenuStore, menuModuleObj, filterModule, firstModule;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return mergeConfig(projectId);

          case 2:
            window.GLOBAL_CONFIG = _context.sent;
            // 合并配置文件
            _getAuthStorage = getAuthStorage(), _getAuthStorage$cooki = _getAuthStorage.cookies, cookies = _getAuthStorage$cooki === void 0 ? '' : _getAuthStorage$cooki, _getAuthStorage$acces = _getAuthStorage.accesstoken, accesstoken = _getAuthStorage$acces === void 0 ? '' : _getAuthStorage$acces;
            if (window.GLOBAL_CONFIG.isCustomTyphoonAnalysis) action.setGlobalState({
              projectId: projectId,
              cookies: cookies,
              token: accesstoken
            }); // 给台风分析子模块传projectId
            // if (getAuthStorage().version !== 'customized' || !getAuthStorage().version) {
            //     auth.init() // 开启用户鉴权
            // } // 不存在判断是历史遗留处理，没有版本号标识

            auth.init(); // 开启用户鉴权

            initSocketIo(); // 开启socket链接

            Object.assign(store.state, window.GLOBAL_CONFIG); // 合并全局配置

            headName = window.GLOBAL_CONFIG.headName;
            if (headName) document.title = headName;
            if (!store.state.Menu) store.registerModule('Menu', MenuModule); // 注册菜单模块
            // 初始化store的地图数据

            initMapTilelayer(store);
            newModule = []; // 代表新配置的路由，主要是取决于是否有外部iframe配置

            _context.next = 15;
            return store.dispatch('initFootBarMenu');

          case 15:
            currentMenuStore = _context.sent;
            // 优先获取菜单,动态根据新的
            currentMenuStore = flatArray(currentMenuStore).filter(function (v) {
              return v.isShow !== false;
            }); // 扁平化成对象

            menuModuleObj = currentMenuStore.reduce(function (i, val) {
              i[val.type] = val;
              var self = !val.target || val.target === 'self'; // 追踪新增模块

              if (!self) {
                if (val.type === 'qxzl') {
                  val.type = "meteorology";
                  newModule.push({
                    path: '/meteorology',
                    name: 'meteorology',
                    component: function component() {
                      return import('@/views/module-meteorology');
                    }
                  });
                } else {
                  newModule.push({
                    path: '/' + val.type,
                    name: val.type,
                    // 提示错误 补全代码 /components/panel-img.vue后正常运行 需要小朱确认
                    component: function component() {
                      return import('@/views/common');
                    },
                    meta: {
                      target: self ? false : val.target,
                      show_menu: val.show_menu
                    }
                  });
                }

                flatCommonArry.push(val.type); // 加入权限
              }

              return i;
            }, {}); // 提取配置文件成对象,默认有个台风监测模块
            // 接下来遍历通用路由的数据内容，和配置的所有路由进行匹配，剔除路由库中没配置的路由
            // console.log("menuModuleObj1", menuModuleObj);

            filterModule = function filterModule(children) {
              var i = children.length;

              while (i--) {
                var item = children[i];

                if (!item.name) {
                  if (item.children && Array.isArray(item.children)) filterModule(item.children);
                  continue;
                }

                var render = item.name.split('-'); // 用-隔开，第一个模块为父模块name

                if (render.length > 1 && !!menuModuleObj[render[0]]) {
                  // 这个模块跟父模块走的
                  flatCommonArry.push(item.name);
                  if (item.children && Array.isArray(item.children)) filterModule(item.children);
                  continue;
                } // 常驻模块保留


                if (item.permanent) {
                  flatCommonArry.push(item.name);
                  if (item.children && Array.isArray(item.children)) filterModule(item.children);
                  continue;
                }

                if (!menuModuleObj[item.name]) children.splice(i, 1);else {
                  flatCommonArry.push(item.name);
                  if (item.children && Array.isArray(item.children)) filterModule(item.children);
                  delete menuModuleObj[item.name];
                }
              }

              return children;
            };

            filterModule(CommonRouter); // 下面代码是处理配置了系统中没有定义的路由菜单，应该指向什么页面

            newModule.forEach(function (item) {
              delete menuModuleObj[item.name];
            });
            if (menuModuleObj.hasOwnProperty("qxzl")) delete menuModuleObj.qxzl;
            Object.keys(menuModuleObj).forEach(function (item) {
              CommonRouter.push({
                name: item,
                path: "/".concat(item)
              });
            });
            firstModule = CommonRouter.find(function (v) {
              return !v.path;
            });
            firstModule && (_firstModule$children = firstModule.children).push.apply(_firstModule$children, newModule); // 合并通用模，都需要带有头部

            router.options.routes = router.options.routes.concat(CommonRouter);
            router.addRoutes(CommonRouter); // 统一添加处理好的路由

            store.state.Menu.currentModule = currentMenuStore; // 记录只显示的菜单

            return _context.abrupt("return", currentMenuStore[0]);

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function initRouter(_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

export var InitRouter = initRouter; // 先给页面登录前进行验证

export default function initStore(_x5, _x6) {
  return _initStore.apply(this, arguments);
} // 判断是否存在这个module

function _initStore() {
  _initStore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(store, router) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!getAuthStorage()) {
              _context3.next = 3;
              break;
            }

            _context3.next = 3;
            return initRouter(store, router, getAuthStorage().projectId);

          case 3:
            router.beforeEach(function (to, from, next) {
              NProgress.start();
              var query = to.query;
              if (to.name !== 'login' && to.name) store.state.routerStacks.push(to); // 路由历史列表
              // 登录放行

              if (to.name === 'login') {
                next();
                NProgress.done();
                return;
              } // 不存在的模块弹出提醒并拦截


              if (!isExitModule(to.name)) {
                _Message({
                  showClose: true,
                  message: '提示：功能即将上线，敬请期待！',
                  customClass: 'common-box'
                });

                next({
                  name: from.name,
                  query: query
                });
                NProgress.done();
                return;
              } // 存在退出登录情况


              if (query.hasOwnProperty('loginout') && query.loginout === 'true') {
                removeAllStorage();
                next({
                  name: 'login',
                  query: {}
                });
                NProgress.done();
                return;
              } // 存在appid情况下


              if (query.hasOwnProperty('appid')) {
                if (getAuthStorage() && getAuthStorage().appid === query.appid) next();else {
                  if (!to.path.includes('login')) {
                    var target = to.path.replace('/', '');
                    query.to = target;
                  }

                  next({
                    name: 'login',
                    query: query
                  });
                }
                NProgress.done();
                return;
              } // 其他情况下看情况同行


              getAuthStorage() ? next() : next({
                name: 'login',
                query: query
              });
              NProgress.done();
            });
            router.afterEach(function () {
              NProgress.done();
              setTimeout(function () {
                checkedInput();
              }, 0);
            });

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _initStore.apply(this, arguments);
}

function isExitModule(type) {
  var whiteList = ['login'];
  if (!type || whiteList.includes(type)) return true;
  var handle = flatCommonArry.findIndex(function (v) {
    return v === type;
  });
  return handle > -1;
} // 输入框过滤sql注入


function checkedInput() {
  var inputs = document.getElementsByTagName('input');

  if (inputs.length) {
    for (var i = 0; i < inputs.length; i++) {
      var element = inputs[i];
      var pat = /select|update|delete|from|exec|count|and|insert*|%|chr|mid|master|truncate|char|declare|'|=|;|%/i;

      element.onblur = function (e) {
        if (pat.test(e.target.value)) {
          e.target.value = '';

          _Message({
            showClose: true,
            message: '请勿在文本框中输入SQL代码类型！',
            customClass: 'common-box'
          });
        }
      };
    }
  }
}